/**
 * Copyright 2021 mmmint.ai info@mmmint.ai - All Rights Reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential to MMM Intelligence UG (haftungsbeschränkt).
 */

/**
 * Type of status of an THG Document.
 */
export enum ThgStatusEnum {
  /**
   *
   */
  CREATED = "created",

  /**
   *
   */
  USER_ADDED_REGISTRATION = "user_added_registration",

  /**
   *
   */
  REQUEST_DATA = "requst_data",

  /**
   * Use this status if registrationimages are not readable
   */
  REQUEST_REGISTRATION_IMAGES = "requst_registration_images",

  /**
   * The car is confirmend and waits for the export to be registered at bundesumweltamt
   */
  CONFIRMED = "confirmed",

  /**
   * thg quote has been applied for at the federal environmental agency
   */
  WAIT_FOR_AGENCY = "wait_for_agency",

  /**
   * thg quote is been confirmed by federal environmental agency
   */
  CONFIRMED_BY_AGENCY = "confirmed_by_agency",

  /**
   * The Quote is paid out
   */
  PAYED = "payed",

  /**
   * Error Stati
   */

  /**
   * The car was already registered in the current year
   */
  DUPLICATE = "duplicate",

  /**
   * The Car is no electric vehicle
   */
  NO_BEV = "no_battery_electric_vehicle",

  /**
   * The THG is spam
   */
  SPAM = "spam",

  /**
   * No German registration Document
   */
  NO_GERMAN_REGISTRATION_DOCUMENT = "no_german_registration_document"
}
